import { render, staticRenderFns } from "./khach-hang-sx.vue?vue&type=template&id=4d5dc7ef&scoped=true&"
import script from "./khach-hang-sx.vue?vue&type=script&lang=js&"
export * from "./khach-hang-sx.vue?vue&type=script&lang=js&"
import style0 from "./khach-hang-sx.vue?vue&type=style&index=0&id=4d5dc7ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5dc7ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
